import { createLogger as ne } from "@origo/logger";
import * as ye from "@arcgis/core/geometry/operators/areaOperator";
import * as fe from "@arcgis/core/geometry/operators/intersectionOperator";
import * as ge from "@arcgis/core/geometry/operators/intersectsOperator";
import pe from "@arcgis/core/layers/support/CodedValueDomain";
import le from "@arcgis/core/request";
import ke from "@arcgis/core/rest/support/FeatureSet";
import be from "@arcgis/core/layers/FeatureLayer";
import { queryOptions as O, useQuery as E } from "@tanstack/react-query";
import { jsx as Re } from "react/jsx-runtime";
import { createContext as Ae, useMemo as Ne, useContext as te } from "react";
function Fe(e) {
  return `${e.planStat ?? ""}-${e.vertNiv ?? ""}-${e.planId ?? ""}-${e.objectId ?? ""}`;
}
class K extends Error {
  constructor(r, n) {
    super(r), this.cause = n, this.name = this.constructor.name;
  }
}
class Oe extends K {
  constructor(r, n) {
    super(`${r} ikke funnet: ${n}`);
  }
}
class Ee extends K {
}
class C extends K {
}
class Se extends K {
}
class J extends K {
  constructor() {
    super("Operasjonen ble avbrutt");
  }
}
class H extends K {
}
const kr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: J,
  ArealplanError: K,
  AuthError: Se,
  ConfigurationError: H,
  NetworkError: C,
  NotFoundError: Oe,
  ValidationError: Ee,
  planKey: Fe
}, Symbol.toStringTag, { value: "Module" })), ae = {
  minRatio: 0.01,
  minAreaM2: 1 / 0
};
function Q(e) {
  try {
    return Math.abs(ye.execute(e, { unit: "square-meters" }));
  } catch {
    return 0;
  }
}
function ue(e, r, n = {}) {
  if (!e || !r)
    return { keep: !0, reason: "missing-geometry" };
  const t = n.minAreaM2 ?? ae.minAreaM2, a = n.minRatio ?? ae.minRatio, o = e.spatialReference?.wkid, i = r.spatialReference?.wkid;
  if (o != null && i != null && o !== i)
    return { keep: !0, reason: "sr-mismatch", srcWkid: o, candWkid: i };
  const s = e, p = r;
  try {
    if (!ge.execute(s, p))
      return { keep: !1, reason: "no-intersect", srcWkid: o, candWkid: i };
  } catch {
    return { keep: !0, reason: "intersect-error", srcWkid: o, candWkid: i };
  }
  let y;
  try {
    y = fe.execute(s, p);
  } catch {
    return { keep: !0, reason: "intersection-error", srcWkid: o, candWkid: i };
  }
  if (!y)
    return o != null && i != null && o === i ? { keep: !1, reason: "touch-no-area", srcWkid: o, candWkid: i, overlapAreaM2: 0, ratio: 0 } : { keep: !0, reason: "intersection-null", srcWkid: o, candWkid: i };
  const T = Q(y), h = Q(e), B = Q(r), l = Math.min(h, B), f = l > 0 ? T / l : 0, d = { srcWkid: o, candWkid: i, overlapAreaM2: T, sourceAreaM2: h, candidateAreaM2: B, ratio: f };
  return f >= a ? { keep: !0, reason: "ratio-pass", ...d } : T >= t ? { keep: !0, reason: "area-pass", ...d } : { keep: !1, reason: "below-threshold", ...d };
}
function oe(e, r, n = {}) {
  return ue(e, r, n).keep;
}
const Ie = /^(Kommuneplan|Kommunedelplan|Reguleringsplan|Bebyggelsesplan)/i, Pe = /^Dispensasjon/i, ve = /^PblMidlForbud/i, ee = {
  // Reguleringsplan (Rp-prefiks) — arealformål
  RpArealformålOmråde: {
    canonical: "RpArealformålOmråde",
    aliases: ["RpArealformålOmråde", "RpArealformalOmrade", "RpArealformaalOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "RPAREALFORMAL"
  },
  RpBestemmelseOmråde: {
    canonical: "RpBestemmelseOmråde",
    aliases: ["RpBestemmelseOmråde", "RpBestemmelseOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "RPBESTEMMELSEHJEMMEL"
  },
  RpAngittHensynSone: {
    canonical: "RpAngittHensynSone",
    aliases: ["RpAngittHensynSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPANGITTHENSYN"
  },
  RpBåndleggingSone: {
    canonical: "RpBåndleggingSone",
    aliases: ["RpBåndleggingSone", "RpBandleggingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPBANDLEGGING"
  },
  RpDetaljeringSone: {
    canonical: "RpDetaljeringSone",
    aliases: ["RpDetaljeringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPDETALJERING"
  },
  RpFareSone: {
    canonical: "RpFareSone",
    aliases: ["RpFareSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPFARE"
  },
  RpGjennomføringSone: {
    canonical: "RpGjennomføringSone",
    aliases: ["RpGjennomføringSone", "RpGjennomforingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPGJENNOMFORING"
  },
  RpInfrastrukturSone: {
    canonical: "RpInfrastrukturSone",
    aliases: ["RpInfrastrukturSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPINFRASTRUKTUR"
  },
  RpSikringSone: {
    canonical: "RpSikringSone",
    aliases: ["RpSikringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPSIKRING"
  },
  RpStøySone: {
    canonical: "RpStøySone",
    aliases: ["RpStøySone", "RpStoySone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "RPSTOY"
  },
  // Reguleringsplan/Bebyggelsesplan etter gammel lov (Rb-prefiks)
  RbArealbrukOmråde: {
    canonical: "RbArealbrukOmråde",
    aliases: ["RbArealbrukOmråde", "RbArealbrukOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFormålOmråde: {
    canonical: "RbFormålOmråde",
    aliases: ["RbFormålOmråde", "RbFormalOmrade", "RbFormaalOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbBevaringOmråde: {
    canonical: "RbBevaringOmråde",
    aliases: ["RbBevaringOmråde", "RbBevaringOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFareOmråde: {
    canonical: "RbFareOmråde",
    aliases: ["RbFareOmråde", "RbFareOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbFornyelseOmråde: {
    canonical: "RbFornyelseOmråde",
    aliases: ["RbFornyelseOmråde", "RbFornyelseOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbRekkefølgeOmråde: {
    canonical: "RbRekkefølgeOmråde",
    aliases: ["RbRekkefølgeOmråde", "RbRekkefolgeOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  RbRestriksjonOmråde: {
    canonical: "RbRestriksjonOmråde",
    aliases: ["RbRestriksjonOmråde", "RbRestriksjonOmrade"],
    headingFelt: "FELTNAVN",
    typeFelt: "REGFORM"
  },
  // Kommuneplan / Kommunedelplan (Kp-prefiks) — arealformål
  KpArealformålOmråde: {
    canonical: "KpArealformålOmråde",
    aliases: ["KpArealformålOmråde", "KpArealformalOmrade"],
    headingFelt: "OMRNAVN",
    typeFelt: "KPAREALFORMAL"
  },
  KpArealbrukOmråde: {
    canonical: "KpArealbrukOmråde",
    aliases: ["KpArealbrukOmråde", "KpArealbrukOmrade"],
    headingFelt: "OMRNAVN",
    typeFelt: "OPLAREAL"
  },
  KpBestemmelseOmråde: {
    canonical: "KpBestemmelseOmråde",
    aliases: ["KpBestemmelseOmråde", "KpBestemmelseOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "KPBESTEMMELSEHJEMMEL"
  },
  KpRestriksjonOmråde: {
    canonical: "KpRestriksjonOmråde",
    aliases: ["KpRestriksjonOmråde", "KpRestriksjonOmrade"],
    headingFelt: "OBJTYPE",
    typeFelt: "OPLRESTR"
  },
  KpRetningslinjeOmråde: {
    canonical: "KpRetningslinjeOmråde",
    aliases: ["KpRetningslinjeOmråde", "KpRetningslinjeOmrade"],
    headingFelt: "OBJTYPE",
    typeFelt: "OPLRETNL"
  },
  KpAngittHensynSone: {
    canonical: "KpAngittHensynSone",
    aliases: ["KpAngittHensynSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPANGITTHENSYN"
  },
  KpBåndleggingSone: {
    canonical: "KpBåndleggingSone",
    aliases: ["KpBåndleggingSone", "KpBandleggingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPBANDLEGGING"
  },
  KpDetaljeringSone: {
    canonical: "KpDetaljeringSone",
    aliases: ["KpDetaljeringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPDETALJERING"
  },
  KpFareSone: {
    canonical: "KpFareSone",
    aliases: ["KpFareSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPFARE"
  },
  KpGjennomføringSone: {
    canonical: "KpGjennomføringSone",
    aliases: ["KpGjennomføringSone", "KpGjennomforingSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPGJENNOMFORING"
  },
  KpInfrastrukturSone: {
    canonical: "KpInfrastrukturSone",
    aliases: ["KpInfrastrukturSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPINFRASTRUKTUR"
  },
  KpSikringSone: {
    canonical: "KpSikringSone",
    aliases: ["KpSikringSone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPSIKRING"
  },
  KpStøySone: {
    canonical: "KpStøySone",
    aliases: ["KpStøySone", "KpStoySone"],
    headingFelt: "HENSYNSONENAVN",
    typeFelt: "KPSTOY"
  },
  // PBL midlertidig (Pbl-prefiks)
  PblMidlByggAnleggOmråde: {
    canonical: "PblMidlByggAnleggOmråde",
    aliases: ["PblMidlByggAnleggOmråde", "PblMidlByggAnleggOmrade"],
    headingFelt: "BESTEMMELSEOMRNAVN",
    typeFelt: "OBJTYPE"
  }
}, z = Array.from(
  new Set(Object.values(ee).flatMap((e) => e.aliases))
);
function _(e) {
  if (!e)
    return;
  const r = ee[e];
  if (r)
    return r;
  for (const n of Object.values(ee))
    if (n.aliases.includes(e))
      return n;
}
const x = {
  Reguleringsplan: ["RpOmrade"],
  Bebyggelsesplan: ["RpOmrade"],
  Kommuneplan: ["KpOmrade"],
  Kommunedelplan: ["KpOmrade"],
  Dispensasjon: ["DispensasjonPunkt"],
  PblMidlForbud: ["PblMidlForbudMotTiltakFlate"]
};
function X(e) {
  if (x[e])
    return x[e];
  const r = e.replace(/(_UA)?(_VN\d+)?$/, "");
  if (x[r])
    return x[r];
  for (const [n, t] of Object.entries(x))
    if (e.includes(n))
      return t;
  return [];
}
const Te = {
  PLANID: "planId",
  LOKALID: "lokalId",
  GlobalID: "globalId",
  OBJECTID: "objectId",
  PLANNAVN: "planNavn",
  PLANSTAT: "planStat",
  PLANTYPE: "planTypeKey",
  VERTNIV: "vertNiv",
  IKRAFT: "ikraft",
  BESKRIVELSE: "beskrivelse",
  KOMMUNENUMMER: "kommunenummer",
  PLANBEST: "planBestemmelser",
  LOVREFERANSE: "lovreferanse",
  PLANREGISTERLINK: "planRegisterLink"
};
function he(e) {
  const r = {};
  if (e)
    for (const [n, t] of Object.entries(e)) {
      const a = Te[n];
      a && t != null && (r[a] = String(t));
    }
  return Object.keys(r).length > 0 ? r : void 0;
}
function ie(e, r, n) {
  return {
    planId: String(e.PLANID ?? ""),
    lokalId: e.LOKALID ?? void 0,
    globalId: e.GlobalID ?? void 0,
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planTypeKey: r,
    planNavn: e.PLANNAVN ?? void 0,
    planStat: e.PLANSTAT ?? void 0,
    vertNiv: e.VERTNIV ?? void 0,
    ikraft: e.IKRAFT ?? void 0,
    beskrivelse: e.BESKRIVELSE ?? void 0,
    kommunenummer: e.KOMMUNENUMMER ?? void 0,
    planBestemmelser: e.PLANBEST ?? void 0,
    lovreferanse: e.LOVREFERANSE ?? void 0,
    planRegisterLink: e.PLANREGISTERLINK ?? void 0,
    displayValues: he(n)
  };
}
function Be(e) {
  if (typeof e.LOKALID == "string" && e.LOKALID.trim() !== "")
    return e.LOKALID.trim();
  if (typeof e.GlobalID == "string" && e.GlobalID.trim() !== "")
    return e.GlobalID.trim();
  const r = e.OBJTYPE, n = e.OBJECTID;
  if (typeof r == "string" && r.trim() !== "" && n != null)
    return `${r.trim()}-${n}`;
}
function Le(e) {
  const r = _(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!r)
    return;
  const n = e[r.typeFelt];
  return n == null ? void 0 : String(n);
}
function je(e, r) {
  const n = _(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!n)
    return;
  const t = r[n.typeFelt];
  return t == null ? void 0 : String(t);
}
function Me(e) {
  const r = _(typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0);
  if (!r)
    return;
  const n = e[r.headingFelt];
  return n == null ? void 0 : String(n);
}
function Z(e, r, n, t) {
  return {
    omradeId: Be(e),
    planId: String(e.PLANID ?? ""),
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    objtype: typeof e.OBJTYPE == "string" ? e.OBJTYPE : void 0,
    arealformål: Le(e),
    arealformålDisplay: je(e, n),
    feltnavn: Me(e),
    geometri: r,
    planTypeKey: t,
    attributter: { ...e },
    displayValues: n
  };
}
const Ke = {
  OBJECTID: "objectId",
  planId: "planId",
  pbltiltak: "pblTiltak",
  beskrivelse: "beskrivelse",
  dispensasjonType: "dispensasjonType",
  vedtaksdato: "vedtaksdato",
  tiltaksnr: "tiltaksnr",
  dispFra: "dispFra",
  vedtakId: "vedtakId",
  vedtak: "vedtak",
  sak_id: "sakId",
  sak_sakAar: "sakAar",
  sak_sakSeknr: "sakSeknr",
  sak_arkivId: "sakArkivId",
  sak_url: "sakUrl",
  sak_urlIntern: "sakUrlIntern",
  vedtak_urlEkstern: "vedtakUrlEkstern"
};
function De(e) {
  const r = {};
  for (const [n, t] of Object.entries(e)) {
    const a = Ke[n];
    r[a ?? n] = t;
  }
  return r;
}
function we(e, r, n, t) {
  return {
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planId: typeof e.planId == "string" ? e.planId : void 0,
    planTypeKey: t,
    pblTiltak: typeof e.pbltiltak == "string" ? e.pbltiltak : void 0,
    beskrivelse: typeof e.beskrivelse == "string" ? e.beskrivelse : void 0,
    dispensasjonType: typeof e.dispensasjonType == "string" ? e.dispensasjonType : void 0,
    vedtaksdato: e.vedtaksdato ?? void 0,
    tiltaksnr: typeof e.tiltaksnr == "string" ? e.tiltaksnr : void 0,
    dispFra: typeof e.dispFra == "string" ? e.dispFra : void 0,
    vedtakId: typeof e.vedtakId == "string" ? e.vedtakId : void 0,
    vedtak: typeof e.vedtak == "string" ? e.vedtak : void 0,
    sakId: typeof e.sak_id == "string" ? e.sak_id : void 0,
    sakAar: e.sak_sakAar ?? void 0,
    sakSeknr: e.sak_sakSeknr ?? void 0,
    sakArkivId: typeof e.sak_arkivId == "string" ? e.sak_arkivId : void 0,
    sakUrl: typeof e.sak_url == "string" ? e.sak_url : void 0,
    sakUrlIntern: typeof e.sak_urlIntern == "string" ? e.sak_urlIntern : void 0,
    vedtakUrlEkstern: typeof e.vedtak_urlEkstern == "string" ? e.vedtak_urlEkstern : void 0,
    geometri: r,
    attributter: { ...e },
    displayValues: De(n)
  };
}
const Ge = {
  OBJECTID: "objectId",
  PBLTILTAKFORBUDTYPE: "tiltakforbudType",
  INFORMASJON: "informasjon",
  AVGJDATO: "avgjørelsesdato",
  GYLDIGTILDATO: "gyldigTilDato",
  FORSTEDIGITALISERINGSDATO: "førsteDigitaliseringsdato",
  SAKSAR: "saksAar",
  SAKSSEKVENSNUMMER: "saksSekvensnummer"
};
function xe(e) {
  const r = {};
  for (const [n, t] of Object.entries(e)) {
    const a = Ge[n];
    r[a ?? n] = t;
  }
  return r;
}
function qe(e, r, n, t) {
  return {
    objectId: e.OBJECTID != null ? Number(e.OBJECTID) : void 0,
    planTypeKey: t,
    tiltakforbudType: typeof e.PBLTILTAKFORBUDTYPE == "string" ? e.PBLTILTAKFORBUDTYPE : void 0,
    informasjon: typeof e.INFORMASJON == "string" ? e.INFORMASJON : void 0,
    avgjørelsesdato: e.AVGJDATO ?? void 0,
    gyldigTilDato: e.GYLDIGTILDATO ?? void 0,
    førsteDigitaliseringsdato: e.FORSTEDIGITALISERINGSDATO ?? void 0,
    saksAar: e.SAKSAR ?? void 0,
    saksSekvensnummer: e.SAKSSEKVENSNUMMER ?? void 0,
    geometri: r,
    attributter: { ...e },
    displayValues: xe(n)
  };
}
function D(e) {
  const r = /* @__PURE__ */ new Map();
  for (const n of e)
    if (n.domain instanceof pe) {
      const t = /* @__PURE__ */ new Map();
      for (const a of n.domain.codedValues)
        t.set(a.code, a.name);
      r.set(n.name, t);
    }
  return r;
}
function w(e, r) {
  const n = {};
  for (const [t, a] of Object.entries(e)) {
    const o = r.get(t);
    n[t] = o?.get(a) ?? a;
  }
  return n;
}
function de(e) {
  return e.replace(/'/g, "''");
}
function Y(e) {
  return `'${de(e)}'`;
}
function br(e, r) {
  return r.length === 0 ? "1=0" : `${e} IN (${r.map(Y).join(",")})`;
}
const $e = ne("arealplan:ServicesInitializer");
function _e() {
  const e = /* @__PURE__ */ new Map(), r = async (o) => {
    try {
      const s = (await le(o, {
        query: { f: "json" },
        responseType: "json"
      })).data?.layers;
      return s ? s.map((p) => ({
        id: p.id,
        name: p.name,
        url: `${o}/${p.id}`,
        geometryType: p.geometryType
      })) : [];
    } catch (i) {
      throw $e.error(`Feil ved henting av layer-info fra ${o}:`, i), new C(`Kunne ikke laste layer-info: ${i?.message ?? i}`, i);
    }
  }, n = (o) => {
    let i = e.get(o);
    return i || (i = r(o).catch((s) => {
      throw e.delete(o), s;
    }), e.set(o, i)), i;
  };
  return { getLayerInfo: n, getLayerIds: async (o, i) => {
    const s = await n(o);
    if (i && i.length > 0) {
      const p = new Set(i);
      return s.filter((y) => p.has(y.name)).map((y) => y.id);
    }
    return s.filter((p) => p.geometryType === "esriGeometryPolygon").map((p) => p.id);
  }, getLayerMap: async (o) => {
    const i = await n(o);
    return new Map(i.map((s) => [s.name, s]));
  } };
}
const Ve = ne("arealplan:queryFeatureLayers"), Ye = 2e3, Ce = 1e3;
async function L(e, r, n) {
  return r.layerIds.length === 0 ? [] : (await Promise.all(
    r.layerIds.map((a) => Je(e, a, r, n))
  )).filter((a) => a !== null);
}
async function Je(e, r, n, t) {
  const a = {
    where: n.where,
    outSR: n.outputWkid,
    returnGeometry: n.returnGeometry !== !1,
    returnTrueCurves: n.returnTrueCurves ?? !1,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    geometryPrecision: 2,
    f: "json"
  };
  n.geometry && (a.geometryType = "esriGeometryPolygon", a.inSR = n.geometry.spatialReference?.wkid ?? n.outputWkid, a.geometry = JSON.stringify(n.geometry.toJSON()), a.spatialRel = "esriSpatialRelIntersects");
  const o = [];
  let i = null, s = 0;
  try {
    for (let y = 0; y < Ce; y++) {
      const h = (await le(`${e}/${r}/query`, {
        query: { ...a, resultOffset: s, resultRecordCount: Ye },
        method: "post",
        responseType: "json",
        signal: t?.signal
      })).data, B = h?.features ?? [];
      if (y === 0 && (i = h), o.push(...B), h?.exceededTransferLimit !== !0 || B.length === 0)
        break;
      s += B.length;
    }
  } catch (y) {
    throw t?.signal?.aborted || He(y) ? new J() : (Ve.error(`Feil ved query mot ${e}/${r}:`, y), new C(
      `Query mot ${e}/${r} feilet: ${y?.message ?? y}`,
      y
    ));
  }
  return !i || o.length === 0 ? null : { featureSet: ke.fromJSON({ ...i, features: o }), layerId: r };
}
function He(e) {
  return typeof e != "object" || e === null ? !1 : e.name === "AbortError";
}
const q = ne("arealplan:arcgisArealplanRepository"), j = 25833;
function $(e) {
  if (e instanceof J)
    throw e;
}
function We(e) {
  if (!e.settings)
    throw new H("createArcgisArealplanRepository: settings required");
  const r = e.services ?? _e(), n = () => Object.entries(e.settings.planTypes).filter(([l]) => Ie.test(l)).map(([l, f]) => [l, f.url]), t = async (l) => {
    const f = n();
    return (await Promise.all(
      f.map(async ([m, g]) => {
        try {
          const u = X(m), A = await r.getLayerMap(g);
          let N;
          for (const F of u) {
            const c = A.get(F);
            if (c) {
              N = c;
              break;
            }
          }
          return N ? (await L(
            g,
            {
              layerIds: [N.id],
              where: "1=1",
              returnGeometry: !1,
              // `*` i stedet for en eksplisitt feltliste: per-lag
              // endepunktet `/{layerId}/query` validerer outFields
              // strengt og avviser HELE queryen om ett felt mangler
              // på laget («'outFields' parameter is invalid»). Det
              // gamle tjeneste-nivå layerDefs-endepunktet var
              // tolerant her. Mapperen plukker felt by-name
              // (WIRE_TO_DOMAIN_KEY), så ekstra felt er uskadelig.
              outputWkid: j
            },
            l
          )).flatMap(({ featureSet: F }) => {
            const c = D(F.fields ?? []);
            return F.features.map(
              (b) => ie(
                b.attributes,
                m,
                w(b.attributes, c)
              )
            );
          }) : [];
        } catch (u) {
          return $(u), q.error(`Feil ved henting av planer fra ${m}:`, u), [];
        }
      })
    )).flat();
  }, a = async (l, f) => (await Promise.all(
    Object.entries(e.settings.planTypes).map(async ([m, g]) => {
      try {
        const u = X(m);
        if (u.length === 0)
          return [];
        const A = await r.getLayerIds(g.url, u);
        return A.length === 0 ? [] : (await L(
          g.url,
          {
            layerIds: A,
            where: "1=1",
            geometry: l,
            outputWkid: l.spatialReference?.wkid ?? j
          },
          f
        )).map(({ featureSet: k }) => (k.features = k.features.filter(
          (F) => oe(l, F.geometry ?? void 0)
        ), { planTypeKey: m, featureSet: k })).filter((k) => k.featureSet.features.length > 0);
      } catch (u) {
        return $(u), q.error(`Feil ved spatial query for ${m}:`, u), [];
      }
    })
  )).flat(), o = async (l, f) => (await a(l, f)).flatMap((m) => {
    const g = D(m.featureSet.fields ?? []);
    return m.featureSet.features.map(
      (u) => ie(
        u.attributes,
        m.planTypeKey,
        w(u.attributes, g)
      )
    );
  }), i = async (l, f) => {
    const d = l.spatialReference?.wkid ?? j;
    return (await Promise.all(
      Object.entries(e.settings.planTypes).map(async ([g, u]) => {
        try {
          const A = await r.getLayerIds(
            u.url,
            z
          );
          return A.length === 0 ? [] : (await L(
            u.url,
            {
              layerIds: A,
              where: "1=1",
              geometry: l,
              outputWkid: d
            },
            f
          )).flatMap(({ featureSet: k }) => {
            const F = D(k.fields ?? []);
            return k.features.filter(
              (c) => oe(l, c.geometry ?? void 0)
            ).map(
              (c) => Z(
                c.attributes,
                c.geometry ?? void 0,
                w(c.attributes, F),
                g
              )
            );
          });
        } catch (A) {
          return $(A), q.error(`Feil ved delområde-query for ${g}:`, A), [];
        }
      })
    )).flat();
  }, s = async (l, f) => {
    if (l.length === 0)
      return [];
    const d = [], m = [], g = /* @__PURE__ */ new Map(), u = /^([^:\-]+)[:-](\d+)$/, A = /^\{?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\}?$/;
    for (const c of l) {
      const b = u.exec(c);
      if (b) {
        const P = b[1], I = Number(b[2]);
        if (Number.isFinite(I)) {
          let v = g.get(P);
          v || (v = [], g.set(P, v)), v.push(I);
          continue;
        }
      }
      if (A.test(c)) {
        m.push(c);
        continue;
      }
      d.push(c);
    }
    const N = [];
    d.length > 0 && N.push(`LOKALID IN (${d.map(Y).join(",")})`), m.length > 0 && N.push(`GlobalID IN (${m.map(Y).join(",")})`);
    for (const [c, b] of g)
      N.push(
        `(OBJTYPE = ${Y(c)} AND OBJECTID IN (${b.join(",")}))`
      );
    const k = N.join(" OR ");
    return (await Promise.all(
      Object.entries(e.settings.planTypes).map(async ([c, b]) => {
        try {
          const P = await r.getLayerIds(
            b.url,
            z
          );
          return P.length === 0 ? [] : (await L(
            b.url,
            {
              layerIds: P,
              where: k,
              outputWkid: j
            },
            f
          )).flatMap(({ featureSet: v }) => {
            const G = D(v.fields ?? []);
            return v.features.map(
              (U) => Z(
                U.attributes,
                U.geometry ?? void 0,
                w(U.attributes, G),
                c
              )
            );
          });
        } catch (P) {
          return $(P), q.error(`Feil ved findDelområderByIds for ${c}:`, P), [];
        }
      })
    )).flat();
  }, p = async (l, f, d, m, g) => {
    const u = e.settings.planTypes[f];
    if (!u)
      return [];
    const A = await r.getLayerIds(u.url, z);
    if (A.length === 0)
      return [];
    const N = g ?? d?.spatialReference?.wkid ?? j;
    return (await L(
      u.url,
      {
        layerIds: A,
        where: `PLANID = '${de(l)}'`,
        geometry: d,
        outputWkid: N
      },
      m
    )).flatMap(({ featureSet: F }) => {
      const c = D(F.fields ?? []);
      return F.features.filter(
        (b) => ue(d, b.geometry ?? void 0, { minAreaM2: 1 }).keep
      ).map(
        (b) => Z(
          b.attributes,
          b.geometry ?? void 0,
          w(b.attributes, c),
          f
        )
      );
    });
  }, y = async (l, f) => {
    const d = e.settings.planTypes[l.planTypeKey];
    if (!d || l.objectId == null)
      return null;
    const m = X(l.planTypeKey), g = await r.getLayerMap(d.url);
    let u;
    for (const N of m) {
      const k = g.get(N);
      if (k) {
        u = k;
        break;
      }
    }
    return u ? (await L(
      d.url,
      {
        layerIds: [u.id],
        where: `OBJECTID = ${l.objectId}`,
        returnGeometry: !0,
        outFields: ["OBJECTID"],
        outputWkid: j
      },
      f
    ))[0]?.featureSet.features[0]?.geometry ?? null : null;
  }, T = async (l, f, d, m, g) => {
    const u = l.spatialReference?.wkid ?? j, A = Object.entries(e.settings.planTypes).filter(
      ([k]) => f.test(k)
    );
    return (await Promise.all(
      A.map(async ([k, F]) => {
        try {
          const b = (await r.getLayerInfo(F.url)).filter((I) => I.geometryType != null).map((I) => I.id);
          return b.length === 0 ? [] : (await L(
            F.url,
            {
              layerIds: b,
              where: "1=1",
              geometry: l,
              outputWkid: u
            },
            g
          )).flatMap(({ featureSet: I }) => {
            const v = D(I.fields ?? []);
            return I.features.map(
              (G) => d(
                G.attributes,
                G.geometry ?? void 0,
                w(G.attributes, v),
                k
              )
            );
          });
        } catch (c) {
          return $(c), q.error(`Feil ved ${m}-query for ${k}:`, c), [];
        }
      })
    )).flat();
  };
  return {
    findAll: t,
    findByPolygon: o,
    findFeaturesByPolygon: a,
    findDelområderByPolygon: i,
    findDelområderByIds: s,
    getDelområderForPlan: p,
    getGeometry: y,
    findDispensasjonerByPolygon: (l, f) => T(
      l,
      Pe,
      (d, m, g, u) => we(
        d,
        m,
        g,
        u
      ),
      "dispensasjon",
      f
    ),
    findMidlertidigeForbudByPolygon: (l, f) => T(
      l,
      ve,
      (d, m, g, u) => qe(
        d,
        m,
        g,
        u
      ),
      "midlertidig forbud",
      f
    )
  };
}
function Ue(e) {
  const { kommunenummer: r, gardsnummer: n, bruksnummer: t, festenummer: a, seksjonsnummer: o } = e;
  if (n == null || t == null)
    return;
  let i = "";
  return r != null && (i += `${r}-`), i += `${n}/${t}`, a && (i += `-${a}`), o && (i += `/${o}`), i;
}
function se(e, r) {
  return {
    objectId: e.OBJECTID,
    id: String(e.matrikkelid ?? e.OBJECTID),
    kommunenummer: e.kommunenummer != null ? Number(e.kommunenummer) : void 0,
    gardsnummer: e.gardsnummer != null ? Number(e.gardsnummer) : void 0,
    bruksnummer: e.bruksnummer != null ? Number(e.bruksnummer) : void 0,
    festenummer: e.festenummer != null ? Number(e.festenummer) : void 0,
    seksjonsnummer: e.seksjonsnummer != null ? Number(e.seksjonsnummer) : void 0,
    matrikkelId: e.matrikkelid != null ? String(e.matrikkelid) : void 0,
    matrikkelnummerTekst: e.matrikkelnummer ?? Ue(e),
    geometri: r
  };
}
function Qe(e) {
  if (!e.teigerUrl)
    throw new H("createArcgisTeigRepository: teigerUrl required");
  let r = null;
  const n = () => (r ?? (r = new be({ url: e.teigerUrl })), r), t = async (o, i) => {
    try {
      return await o();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? new J() : new C(`${i} feilet: ${s?.message ?? s}`, s);
    }
  }, a = async (o, i) => t(async () => {
    const s = n().createQuery();
    return s.where = o, s.outFields = ["*"], s.returnGeometry = !0, (await n().queryFeatures(s, { signal: i?.signal })).features.map(
      (y) => se(
        y.attributes,
        y.geometry
      )
    );
  }, "TeigRepository.query");
  return {
    findByMatrikkel: async (o, i) => {
      const s = [];
      return s.push(`gardsnummer = ${o.gardsnummer}`), s.push(`bruksnummer = ${o.bruksnummer}`), s.push(`kommunenummer = ${o.kommunenummer}`), o.festenummer != null && s.push(`festenummer = ${o.festenummer}`), o.seksjonsnummer != null && s.push(`seksjonsnummer = ${o.seksjonsnummer}`), a(s.join(" AND "), i);
    },
    findByGeometry: async (o, i) => t(async () => {
      const s = n().createQuery();
      return s.geometry = o, s.spatialRelationship = "intersects", s.outFields = ["*"], s.returnGeometry = !0, (await n().queryFeatures(s, { signal: i?.signal })).features.map(
        (y) => se(
          y.attributes,
          y.geometry
        )
      );
    }, "TeigRepository.findByGeometry")
  };
}
function Rr(e) {
  if (!e.settings)
    throw new H("createArealplanClient: settings required");
  const r = We({ settings: e.settings }), n = e.settings.teigerUrl ? Qe({ teigerUrl: e.settings.teigerUrl }) : void 0;
  return { arealplaner: r, teiger: n };
}
const R = {
  all: ["arealplan"],
  list: () => ["arealplan", "list"],
  byPolygon: (e, r, n, t, a) => ["arealplan", "byPolygon", e, r, n, t, a],
  featuresByPolygon: (e, r, n, t, a) => ["arealplan", "featuresByPolygon", e, r, n, t, a],
  delområder: {
    all: ["arealplan", "delområder"],
    byPolygon: (e, r, n, t, a) => ["arealplan", "delområder", "byPolygon", e, r, n, t, a],
    byIds: (e) => ["arealplan", "delområder", "byIds", [...e].sort().join(",")],
    forPlan: (e, r, n = 0, t = 0, a = 0, o = 0, i = 0) => [
      "arealplan",
      "delområder",
      "forPlan",
      e,
      r,
      n,
      t,
      a,
      o,
      i
    ]
  },
  geometry: (e, r, n) => ["arealplan", "geometry", e, r, n ?? 0],
  teiger: {
    byMatrikkel: (e, r, n, t, a) => ["arealplan", "teiger", "matrikkel", e, r, n, t, a],
    byGeometry: (e, r, n) => ["arealplan", "teiger", "geometry", e, r, n]
  },
  dispensasjoner: {
    byPolygon: (e, r, n, t, a) => ["arealplan", "dispensasjoner", "byPolygon", e, r, n, t, a]
  },
  midlertidigeForbud: {
    byPolygon: (e, r, n, t, a) => ["arealplan", "midlertidigeForbud", "byPolygon", e, r, n, t, a]
  }
};
async function ze(e, r) {
  return e.arealplaner.findAll(r);
}
async function Xe(e, r, n) {
  return e.arealplaner.findByPolygon(r.polygon, n);
}
async function Ze(e, r, n) {
  return e.arealplaner.findFeaturesByPolygon(r.polygon, n);
}
async function er(e, r, n) {
  return e.arealplaner.findDelområderByPolygon(r.polygon, n);
}
async function rr(e, r, n) {
  return e.arealplaner.findDelområderByIds(r.omradeIds, n);
}
async function nr(e, r, n) {
  return e.arealplaner.getDelområderForPlan(
    r.planId,
    r.planTypeKey,
    r.polygon,
    n,
    r.outputWkid
  );
}
async function tr(e, r, n) {
  return e.arealplaner.getGeometry(r.plan, n);
}
async function ar(e, r, n) {
  return e.teiger.findByMatrikkel(r, n);
}
async function or(e, r, n) {
  return e.teiger.findByGeometry(r.geometry, n);
}
async function ir(e, r, n) {
  return e.arealplaner.findDispensasjonerByPolygon(r.polygon, n);
}
async function sr(e, r, n) {
  return e.arealplaner.findMidlertidigeForbudByPolygon(r.polygon, n);
}
const V = 5 * 6e4, M = 6e4, lr = (e) => ({
  list: () => O({
    queryKey: R.list(),
    queryFn: ({ signal: r }) => ze(e, { signal: r }),
    staleTime: V
  }),
  byPolygon: (r) => O({
    queryKey: r ? R.byPolygon(
      r.extent?.xmin ?? 0,
      r.extent?.ymin ?? 0,
      r.extent?.xmax ?? 0,
      r.extent?.ymax ?? 0,
      r.spatialReference?.wkid ?? 0
    ) : R.byPolygon(0, 0, 0, 0, 0),
    queryFn: ({ signal: n }) => Xe(e, { polygon: r }, { signal: n }),
    enabled: r != null,
    staleTime: M
  }),
  featuresByPolygon: (r) => O({
    queryKey: r ? R.featuresByPolygon(
      r.extent?.xmin ?? 0,
      r.extent?.ymin ?? 0,
      r.extent?.xmax ?? 0,
      r.extent?.ymax ?? 0,
      r.spatialReference?.wkid ?? 0
    ) : R.featuresByPolygon(0, 0, 0, 0, 0),
    queryFn: ({ signal: n }) => Ze(e, { polygon: r }, { signal: n }),
    enabled: r != null,
    staleTime: M
  }),
  delområder: {
    byPolygon: (r) => O({
      queryKey: r ? R.delområder.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : R.delområder.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => er(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: M
    }),
    byIds: (r) => O({
      queryKey: R.delområder.byIds(r),
      queryFn: ({ signal: n }) => rr(e, { omradeIds: r }, { signal: n }),
      enabled: r.length > 0,
      staleTime: M
    }),
    forPlan: (r, n, t, a) => O({
      // outputWkid MÅ inn i nøkkelen — uten polygon skiller den ellers
      // ikke 25832- fra 25833-resultater, og cachen ville servert feil-SR
      // geometri til kart-rendering.
      queryKey: t ? R.delområder.forPlan(
        r ?? "",
        n ?? "",
        t.extent?.xmin ?? 0,
        t.extent?.ymin ?? 0,
        t.extent?.xmax ?? 0,
        t.extent?.ymax ?? 0,
        t.spatialReference?.wkid ?? 0
      ) : R.delområder.forPlan(
        r ?? "",
        n ?? "",
        0,
        0,
        0,
        0,
        a ?? 0
      ),
      queryFn: ({ signal: o }) => nr(
        e,
        {
          planId: r,
          planTypeKey: n,
          polygon: t ?? void 0,
          outputWkid: a
        },
        { signal: o }
      ),
      enabled: !!(r && n),
      staleTime: M
    })
  },
  geometry: (r) => O({
    queryKey: r ? R.geometry(r.planId, r.planTypeKey, r.objectId) : R.geometry("", "", 0),
    queryFn: ({ signal: n }) => tr(e, { plan: r }, { signal: n }),
    enabled: r != null,
    staleTime: V
  }),
  dispensasjoner: {
    byPolygon: (r) => O({
      queryKey: r ? R.dispensasjoner.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : R.dispensasjoner.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => ir(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: M
    })
  },
  midlertidigeForbud: {
    byPolygon: (r) => O({
      queryKey: r ? R.midlertidigeForbud.byPolygon(
        r.extent?.xmin ?? 0,
        r.extent?.ymin ?? 0,
        r.extent?.xmax ?? 0,
        r.extent?.ymax ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : R.midlertidigeForbud.byPolygon(0, 0, 0, 0, 0),
      queryFn: ({ signal: n }) => sr(e, { polygon: r }, { signal: n }),
      enabled: r != null,
      staleTime: M
    })
  },
  teiger: {
    byMatrikkel: (r) => O({
      queryKey: R.teiger.byMatrikkel(
        r?.kommunenummer ?? 0,
        r?.gardsnummer ?? 0,
        r?.bruksnummer ?? 0,
        r?.festenummer ?? 0,
        r?.seksjonsnummer ?? 0
      ),
      queryFn: ({ signal: n }) => {
        if (!e.teiger)
          throw new Error("TeigRepository not configured");
        return ar(
          { teiger: e.teiger },
          r,
          { signal: n }
        );
      },
      enabled: r != null && e.teiger != null,
      staleTime: V
    }),
    byGeometry: (r) => O({
      queryKey: r ? R.teiger.byGeometry(
        r.x ?? 0,
        r.y ?? 0,
        r.spatialReference?.wkid ?? 0
      ) : R.teiger.byGeometry(0, 0, 0),
      queryFn: ({ signal: n }) => {
        if (!e.teiger)
          throw new Error("TeigRepository not configured");
        return or(
          { teiger: e.teiger },
          { geometry: r },
          { signal: n }
        );
      },
      enabled: r != null && e.teiger != null,
      staleTime: V
    })
  }
});
function re(e, r) {
  if (e.attributter[r] != null)
    return e.attributter[r];
  const n = r.toLowerCase();
  for (const [t, a] of Object.entries(e.attributter))
    if (t.toLowerCase() === n && a != null)
      return a;
}
function me(e, r) {
  return re(e, r) ?? e.displayValues[r];
}
function ce(e) {
  return Array.from(
    new Set(
      e.filter((r) => r != null).map((r) => String(r).trim()).filter(Boolean)
    )
  );
}
function Ar(e) {
  if (e.arealformål)
    return [e.arealformål];
  const r = _(e.objtype);
  if (!r)
    return [];
  const n = me(e, r.typeFelt);
  return ce([n]);
}
function Nr(e) {
  const r = _(e.objtype), n = r ? me(e, r.headingFelt) : void 0, t = e.objtype, a = e.objectId, o = re(e, "GlobalID"), i = re(e, "LOKALID"), s = o == null ? void 0 : String(o).replace(/[{}]/g, "").trim(), p = [
    n,
    i,
    o,
    s,
    s ? s.toLowerCase() : void 0,
    s ? s.toUpperCase() : void 0,
    s ? `{${s}}` : void 0,
    s ? `{${s.toUpperCase()}}` : void 0,
    a,
    t && a ? `${t}-${a}` : void 0,
    a ? `undefined-${a}` : void 0
  ];
  return ce(p);
}
const W = Ae(null), Fr = ({
  client: e,
  children: r
}) => {
  const n = Ne(
    () => ({
      client: e,
      queries: lr({
        arealplaner: e.arealplaner,
        teiger: e.teiger
      })
    }),
    [e]
  );
  return /* @__PURE__ */ Re(W.Provider, { value: n, children: r });
};
function Or() {
  const e = te(W);
  if (!e)
    throw new Error("useArealplanClient må brukes innenfor en <ArealplanClientProvider>");
  return e.client;
}
function Er() {
  return te(W)?.client ?? null;
}
function S() {
  const e = te(W);
  if (!e)
    throw new Error("useArealplanQueries må brukes innenfor en <ArealplanClientProvider>");
  return e.queries;
}
function Sr() {
  const e = S();
  return E(e.list());
}
function Ir(e) {
  const r = S();
  return E(r.byPolygon(e));
}
function Pr(e) {
  const r = S();
  return E(r.featuresByPolygon(e));
}
function vr(e) {
  const r = S();
  return E(r.geometry(e));
}
function Tr(e) {
  const r = S();
  return E(r.dispensasjoner.byPolygon(e));
}
function hr(e) {
  const r = S();
  return E(r.midlertidigeForbud.byPolygon(e));
}
function Br(e) {
  const r = S();
  return E(r.delområder.byPolygon(e));
}
function Lr(e) {
  const r = S();
  return E(r.delområder.byIds(e));
}
function jr(e, r, n, t) {
  const a = S();
  return E(a.delområder.forPlan(e, r, n, t));
}
function Mr(e) {
  const r = S();
  return E(r.teiger.byMatrikkel(e));
}
function Kr(e) {
  const r = S();
  return E(r.teiger.byGeometry(e));
}
class Dr {
  constructor(r = {}) {
    this.data = r;
  }
  async findAll() {
    return [...this.data.arealplaner ?? []];
  }
  async findByPolygon() {
    return [...this.data.arealplaner ?? []];
  }
  async findFeaturesByPolygon() {
    return [];
  }
  async findDelområderByPolygon() {
    return [...this.data.delområder ?? []];
  }
  async findDelområderByIds(r) {
    const n = new Set(r);
    return (this.data.delområder ?? []).filter((t) => t.omradeId && n.has(t.omradeId));
  }
  async getDelområderForPlan(r) {
    return (this.data.delområder ?? []).filter((n) => n.planId === r);
  }
  async getGeometry() {
    return null;
  }
  async findDispensasjonerByPolygon() {
    return [...this.data.dispensasjoner ?? []];
  }
  async findMidlertidigeForbudByPolygon() {
    return [...this.data.midlertidigeForbud ?? []];
  }
}
class wr {
  constructor(r = []) {
    this.teiger = r;
  }
  async findByMatrikkel(r) {
    return this.teiger.filter(
      (n) => n.kommunenummer === r.kommunenummer && n.gardsnummer === r.gardsnummer && n.bruksnummer === r.bruksnummer && (r.festenummer == null || n.festenummer === r.festenummer) && (r.seksjonsnummer == null || n.seksjonsnummer === r.seksjonsnummer)
    );
  }
  async findByGeometry() {
    return [...this.teiger];
  }
}
export {
  z as ALL_DELOMRADE_SUBLAYER_NAMES,
  J as AbortedError,
  Fr as ArealplanClientProvider,
  K as ArealplanError,
  Se as AuthError,
  H as ConfigurationError,
  Dr as FakeArealplanRepository,
  wr as FakeTeigRepository,
  C as NetworkError,
  Oe as NotFoundError,
  ee as OBJTYPE_REGISTRY,
  Ee as ValidationError,
  ie as arealplanFromAttrs,
  R as arealplanKeys,
  lr as arealplanQueries,
  D as buildFieldLookup,
  br as buildInClause,
  We as createArcgisArealplanRepository,
  Qe as createArcgisTeigRepository,
  Rr as createArealplanClient,
  Z as delområdeFromFeature,
  we as dispensasjonFromFeature,
  kr as domain,
  de as escapeSqlValue,
  Ze as findArealplanFeaturesByPolygon,
  Xe as findArealplanerByPolygon,
  rr as findDelområderByIds,
  er as findDelområderByPolygon,
  ir as findDispensasjonerByPolygon,
  sr as findMidlertidigeForbudByPolygon,
  _ as findObjtypeInfo,
  or as findTeigByGeometry,
  ar as findTeigByMatrikkel,
  Ar as getArealformålCandidates,
  tr as getArealplanGeometry,
  Nr as getOmrådeIdCandidates,
  X as getPlanomradeLagnavn,
  ze as loadAlleArealplaner,
  nr as loadDelområderForArealplan,
  w as mapDisplayValues,
  qe as midlertidigForbudFromFeature,
  Fe as planKey,
  Y as qv,
  se as teigFromAttrs,
  Or as useArealplanClient,
  Er as useArealplanClientOptional,
  Pr as useArealplanFeaturesByPolygon,
  vr as useArealplanGeometry,
  Sr as useArealplaner,
  Ir as useArealplanerByPolygon,
  Lr as useDelområderByIds,
  Br as useDelområderByPolygon,
  jr as useDelområderForArealplan,
  Tr as useDispensasjonerByPolygon,
  hr as useMidlertidigeForbudByPolygon,
  Kr as useTeigByGeometry,
  Mr as useTeigByMatrikkel
};
//# sourceMappingURL=index.mjs.map
